import React, { useContext } from 'react'

export const Context = React.createContext({})

export const withContext = (Component) => {
  const WrappedComponent = (props) => {
    const contextProps = useContext(Context)
    return (
      <Component
        {...contextProps}
        {...props}
      />
    )
  }
  return WrappedComponent
}
